interface IFormSubmitProps {
  path: string;
  params: { [key: string]: string };
  method?: "post" | "get";
}

function formSubmit({ path, params, method = "post" }: IFormSubmitProps) {
  // The rest of this code assumes you are not using a library.
  // It can be made less verbose if you use one.
  const form = document.createElement("form");
  form.method = method;
  form.action = path;

  for (const key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

const ENABLE_MASK_VALIDATION = false;

function handleMaskedValueValidation(
  val?: string,
  cb?: () => boolean | string
) {
  if (ENABLE_MASK_VALIDATION && val?.includes("*")) {
    return true;
  }
  return cb?.() ?? true;
}

export { formSubmit, handleMaskedValueValidation };
